export default {
    setOrders(state, payload){
        state.orders = payload;
    },

    setPages(state, payload){
        state.pages = payload;
    }
}